export default __webpack_public_path__ + "static/Angle_of_View_6mm_Lense-9d212159e6d828e6b02c8a63581135cf.webp";